import { ApiUrl } from "../components/Common/ApiUrl";
import { Constants } from "../components/Common/Constants";
import httpServiceInstance from "../helper/HttpService";

export const frequentUsers = async (data) => {
  const url = `${ApiUrl.FREQUENT_USERS}${
    data?.skipPagination
      ? `?${Constants.paginationFalse}`
      : `?skip=${data?.skip || 0}&limit=${data?.limit || Constants.limitCount}`
  }${data && data?.search ? `&search=${data?.search}` : ""}&ascending=${
    data?.ascending || -1
  }${data?.gender ? `&gender=${data?.gender}` : ""}${
    data?.startDate ? `&startDate=${encodeURIComponent(data.startDate)}` : ""
  }${data?.endDate ? `&endDate=${encodeURIComponent(data.endDate)}` : ""}`;
  const response = await httpServiceInstance.get(url);
  return response;
};

export const getWorkoutAnalytics = async (data) => {
  const response = await httpServiceInstance.get(
    ApiUrl.WORKOUT_ANALYTICS +
      `?days=${data?.days}${data?.mode ? `&mode=${data?.mode}` : ""}${
        data?.gender ? `&gender=${data?.gender}` : ""
      }${data?.bodyPart ? `&exerciseCategoryId=${data?.bodyPart}` : ""}${
        data?.assessExer ? `&exerciseId=${data?.assessExer}` : ""
      }`
  );
  return response;
};

export const getAssessExercises = async () => {
  const response = await httpServiceInstance.get(
    ApiUrl.STRENGTH_ASSESS_EXERCISE
  );
  return response;
};

/// //////////////////////////////////////

// export const getTotalWorkoutReport = async (data) => {
//   const response = await httpServiceInstance.get(
//     ApiUrl.TOTAL_WORKOUT_REPORT +
//       `?noofdays=${data?.noofdays}${data?.mode ? `&mode=${data?.mode}` : ""}${
//         data?.gender ? `&gender=${data?.gender}` : ""
//       }${data?.bodyPart ? `&exerciseCategoryId=${data?.bodyPart}` : ""}${
//         data?.assessExer ? `&exerciseId=${data?.assessExer}` : ""
//       }`
//   );
//   return response;
// };

export const getTotalWorkoutReport = async (data) => {
const response = await httpServiceInstance.get(
  ApiUrl.TOTAL_WORKOUT_REPORT +
    `?noOfDays=${data?.noofdays}` +
    (data?.mode ? `&mode=${data.mode}` : "") +
    (data?.gender ? `&gender=${data.gender}` : "") +
    (data?.bodyPart ? `&exerciseCategoryId=${data.bodyPart}` : "") +
    (data?.assessExer ? `&exerciseId=${data.assessExer}` : "") +
    (data?.tz ? `&tz=${data.tz}` : "") +
    (data?.currentDate ? `&currentDate=${encodeURIComponent(data.currentDate)}` : "")
);


  return response;
};


// export const getStrengthAssessmentReport = async (data) => {
//   const response = await httpServiceInstance.get(
//     ApiUrl.STRENGTH_ASSESSMENT_REPORT +
//       `?noofdays=${data?.noofdays}${data?.mode ? `&mode=${data?.mode}` : ""}${
//         data?.gender ? `&gender=${data?.gender}` : ""
//       }${data?.bodyPart ? `&exerciseCategoryId=${data?.bodyPart}` : ""}${
//         data?.assessExer ? `&exerciseId=${data?.assessExer}` : ""
//       }`
//   );
//   return response;
// };


export const getStrengthAssessmentReport = async (data) => {
  const response = await httpServiceInstance.get(
    ApiUrl.STRENGTH_ASSESSMENT_REPORT +
    `?noOfDays=${data?.noofdays}` +
    (data?.mode ? `&mode=${data.mode}` : "") +
    (data?.gender ? `&gender=${data.gender}` : "") +
    (data?.bodyPart ? `&exerciseCategoryId=${data.bodyPart}` : "") +
    (data?.assessExer ? `&exerciseId=${data.assessExer}` : "") +
    (data?.tz ? `&tz=${data.tz}` : "") +
    (data?.currentDate ? `&currentDate=${encodeURIComponent(data.currentDate)}` : "")
  );
  return response;
};

export const getUserGoalCountReport = async (data) => {
  const response = await httpServiceInstance.get(
    ApiUrl.USER_GOAL_COUNT_REPORT +
       `?noOfDays=${data?.noofdays}` +
    (data?.mode ? `&mode=${data.mode}` : "") +
    (data?.gender ? `&gender=${data.gender}` : "") +
    (data?.bodyPart ? `&exerciseCategoryId=${data.bodyPart}` : "") +
    (data?.assessExer ? `&exerciseId=${data.assessExer}` : "") +
    (data?.tz ? `&tz=${data.tz}` : "") +
    (data?.currentDate ? `&currentDate=${encodeURIComponent(data.currentDate)}` : "")
  );
  return response;
};

export const getWorkoutCompletedReport = async (data) => {
  const response = await httpServiceInstance.get(
    ApiUrl.WORKOUT_COMPLETED_REPORT +
     `?noOfDays=${data?.noofdays}` +
    (data?.mode ? `&mode=${data.mode}` : "") +
    (data?.gender ? `&gender=${data.gender}` : "") +
    (data?.bodyPart ? `&exerciseCategoryId=${data.bodyPart}` : "") +
    (data?.assessExer ? `&exerciseId=${data.assessExer}` : "") +
    (data?.tz ? `&tz=${data.tz}` : "") +
    (data?.currentDate ? `&currentDate=${encodeURIComponent(data.currentDate)}` : "")
  );
  return response;
};

export const getExerciseWiseStrengthAssessmentReport = async (data) => {
  const response = await httpServiceInstance.get(
    ApiUrl.EXERCISE_WISE_STRENGTH_ASSESSMENT_REPORT +
   `?noOfDays=${data?.noofdays}` +
    (data?.mode ? `&mode=${data.mode}` : "") +
    (data?.gender ? `&gender=${data.gender}` : "") +
    (data?.bodyPart ? `&exerciseCategoryId=${data.bodyPart}` : "") +
    (data?.assessExer ? `&exerciseId=${data.assessExer}` : "") +
    (data?.tz ? `&tz=${data.tz}` : "") +
    (data?.currentDate ? `&currentDate=${encodeURIComponent(data.currentDate)}` : "")
  );
  return response;
};

export const getExerciseCategoryWiseWorkoutCompletedReport = async (data) => {
  const response = await httpServiceInstance.get(
    ApiUrl.EXERCISE_CATEGORY_WISE_WORKOUT_COMPLETED_REPORT +
     `?noOfDays=${data?.noofdays}` +
    (data?.mode ? `&mode=${data.mode}` : "") +
    (data?.gender ? `&gender=${data.gender}` : "") +
    (data?.bodyPart ? `&exerciseCategoryId=${data.bodyPart}` : "") +
    (data?.assessExer ? `&exerciseId=${data.assessExer}` : "") +
    (data?.tz ? `&tz=${data.tz}` : "") +
    (data?.currentDate ? `&currentDate=${encodeURIComponent(data.currentDate)}` : "")
  );
  return response;
};


export const getTotalWeightsLiftedReport = async (data) => {
  const response = await httpServiceInstance.get(
    ApiUrl.TOTAL_WEIGHTS_LIFTED_REPORT +
     `?noOfDays=${data?.noofdays}` +
    (data?.mode ? `&mode=${data.mode}` : "") +
    (data?.gender ? `&gender=${data.gender}` : "") +
    (data?.bodyPart ? `&exerciseCategoryId=${data.bodyPart}` : "") +
    (data?.assessExer ? `&exerciseId=${data.assessExer}` : "") +
    (data?.tz ? `&tz=${data.tz}` : "") +
    (data?.currentDate ? `&currentDate=${encodeURIComponent(data.currentDate)}` : "")
  );
  return response;
};


export const getWorkoutSessionsSplitMinutes = async (data) => {
  const response = await httpServiceInstance.get(
    ApiUrl.WORKOUT_SESSION_SPLIT_MINUTES +
     `?noOfDays=${data?.noofdays}` +
    (data?.mode ? `&mode=${data.mode}` : "") +
    (data?.gender ? `&gender=${data.gender}` : "") +
    (data?.bodyPart ? `&exerciseCategoryId=${data.bodyPart}` : "") +
    (data?.assessExer ? `&exerciseId=${data.assessExer}` : "") +
    (data?.tz ? `&tz=${data.tz}` : "") +
    (data?.currentDate ? `&currentDate=${encodeURIComponent(data.currentDate)}` : "")
  );
  return response;
};

export const getTotalWorkoutsCompletedHourlyWise = async (data) => {
  const response = await httpServiceInstance.get(
    ApiUrl.TOTAL_WORKOUTS_COMPLETED_HOURLY_WISE +
     `?noOfDays=${data?.noofdays}` +
    (data?.mode ? `&mode=${data.mode}` : "") +
    (data?.gender ? `&gender=${data.gender}` : "") +
    (data?.bodyPart ? `&exerciseCategoryId=${data.bodyPart}` : "") +
    (data?.assessExer ? `&exerciseId=${data.assessExer}` : "") +
    (data?.tz ? `&tz=${data.tz}` : "") +
    (data?.currentDate ? `&currentDate=${encodeURIComponent(data.currentDate)}` : "")
  );
  return response;
};
